function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
import { ConnectionType } from '@sky-uk-ott/client-lib-js-device';
import { ConvivaTagsProvider } from '../../../addons/reporting/conviva-addon/proposition/conviva-tags-provider';
import { PlaybackType } from '../../../core/player/playout-data';
import { LegacyReportingStreamType } from './oneapp-reporting.enums';
export { LegacyReportingStreamType } from './oneapp-reporting.enums';
export var OneAppConvivaTagsProvider = /*#__PURE__*/ function(ConvivaTagsProvider) {
    "use strict";
    _inherits(OneAppConvivaTagsProvider, ConvivaTagsProvider);
    function OneAppConvivaTagsProvider() {
        _class_call_check(this, OneAppConvivaTagsProvider);
        return _call_super(this, OneAppConvivaTagsProvider, arguments);
    }
    _create_class(OneAppConvivaTagsProvider, [
        {
            key: "getAdsmart",
            value: function getAdsmart() {
                return undefined;
            }
        },
        {
            key: "getAccountSegments",
            value: function getAccountSegments() {
                return undefined;
            }
        },
        {
            key: "getSerialNumber",
            value: function getSerialNumber() {
                return undefined;
            }
        },
        {
            key: "getAppVersion",
            value: function getAppVersion() {
                return undefined;
            }
        },
        {
            key: "getContentType",
            value: function getContentType(adaptedMetadata) {
                return undefined;
            }
        },
        {
            key: "isValidPlaybackType",
            value: function isValidPlaybackType() {
                return undefined;
            }
        },
        {
            key: "getDeviceId",
            value: function getDeviceId() {
                var _this_sessionItem_reporting, _this_sessionItem, _this_convivaAddonInfo_deviceInformation, _this_convivaAddonInfo;
                return ((_this_sessionItem = this.sessionItem) === null || _this_sessionItem === void 0 ? void 0 : (_this_sessionItem_reporting = _this_sessionItem.reporting) === null || _this_sessionItem_reporting === void 0 ? void 0 : _this_sessionItem_reporting.deviceId) || ((_this_convivaAddonInfo = this.convivaAddonInfo) === null || _this_convivaAddonInfo === void 0 ? void 0 : (_this_convivaAddonInfo_deviceInformation = _this_convivaAddonInfo.deviceInformation) === null || _this_convivaAddonInfo_deviceInformation === void 0 ? void 0 : _this_convivaAddonInfo_deviceInformation.uniqueDeviceId);
            }
        },
        {
            key: "getStreamProtocol",
            value: function getStreamProtocol() {
                var _this_playoutData_stream, _this_playoutData;
                return (_this_playoutData = this.playoutData) === null || _this_playoutData === void 0 ? void 0 : (_this_playoutData_stream = _this_playoutData.stream) === null || _this_playoutData_stream === void 0 ? void 0 : _this_playoutData_stream.protocol;
            }
        },
        {
            key: "getPlayerName",
            value: function getPlayerName() {
                var _this_convivaAddonInfo;
                return (_this_convivaAddonInfo = this.convivaAddonInfo) === null || _this_convivaAddonInfo === void 0 ? void 0 : _this_convivaAddonInfo.playerName;
            }
        },
        {
            key: "getAdStreamUrl",
            value: function getAdStreamUrl() {
                return undefined;
            }
        },
        {
            key: "getAppSessionId",
            value: function getAppSessionId() {
                var _this_sessionItem_reporting_assetMetadata, _this_sessionItem_reporting, _this_sessionItem;
                return (_this_sessionItem = this.sessionItem) === null || _this_sessionItem === void 0 ? void 0 : (_this_sessionItem_reporting = _this_sessionItem.reporting) === null || _this_sessionItem_reporting === void 0 ? void 0 : (_this_sessionItem_reporting_assetMetadata = _this_sessionItem_reporting.assetMetadata) === null || _this_sessionItem_reporting_assetMetadata === void 0 ? void 0 : _this_sessionItem_reporting_assetMetadata.appSessionId;
            }
        },
        {
            key: "getBrand",
            value: function getBrand() {
                var _this_sessionItem_reporting_assetMetadata, _this_sessionItem_reporting, _this_sessionItem;
                return (_this_sessionItem = this.sessionItem) === null || _this_sessionItem === void 0 ? void 0 : (_this_sessionItem_reporting = _this_sessionItem.reporting) === null || _this_sessionItem_reporting === void 0 ? void 0 : (_this_sessionItem_reporting_assetMetadata = _this_sessionItem_reporting.assetMetadata) === null || _this_sessionItem_reporting_assetMetadata === void 0 ? void 0 : _this_sessionItem_reporting_assetMetadata.brand;
            }
        },
        {
            key: "getConnectionType",
            value: function getConnectionType(deviceNetworkStatus) {
                var _deviceNetworkStatus_getNetworkConnectionType;
                var networkType = deviceNetworkStatus === null || deviceNetworkStatus === void 0 ? void 0 : (_deviceNetworkStatus_getNetworkConnectionType = deviceNetworkStatus.getNetworkConnectionType) === null || _deviceNetworkStatus_getNetworkConnectionType === void 0 ? void 0 : _deviceNetworkStatus_getNetworkConnectionType.call(deviceNetworkStatus);
                switch(networkType){
                    case ConnectionType.Bluetooth:
                        return 'Bluetooth';
                    case ConnectionType.Ethernet:
                        return 'Ethernet';
                    case ConnectionType.Cellular:
                        return 'Cellular';
                    case ConnectionType.Mixed:
                        return 'Mixed';
                    case ConnectionType.Other:
                        return 'Other';
                    case ConnectionType.Unknown:
                    case ConnectionType.Wifi:
                    case undefined:
                        return 'WiFi';
                    default:
                        return networkType;
                }
            }
        },
        {
            key: "getEpisodeTitle",
            value: function getEpisodeTitle() {
                var _this_sessionItem_reporting_assetMetadata, _this_sessionItem_reporting, _this_sessionItem;
                return (_this_sessionItem = this.sessionItem) === null || _this_sessionItem === void 0 ? void 0 : (_this_sessionItem_reporting = _this_sessionItem.reporting) === null || _this_sessionItem_reporting === void 0 ? void 0 : (_this_sessionItem_reporting_assetMetadata = _this_sessionItem_reporting.assetMetadata) === null || _this_sessionItem_reporting_assetMetadata === void 0 ? void 0 : _this_sessionItem_reporting_assetMetadata.episodeTitle;
            }
        },
        {
            key: "isPreFetched",
            value: function isPreFetched() {
                var _this_playoutData;
                return !!((_this_playoutData = this.playoutData) === null || _this_playoutData === void 0 ? void 0 : _this_playoutData.prefetch);
            }
        },
        {
            key: "getSeason",
            value: function getSeason() {
                var _this_sessionItem_reporting_assetMetadata_seasonNumber, _this_sessionItem_reporting_assetMetadata, _this_sessionItem_reporting, _this_sessionItem;
                return (_this_sessionItem = this.sessionItem) === null || _this_sessionItem === void 0 ? void 0 : (_this_sessionItem_reporting = _this_sessionItem.reporting) === null || _this_sessionItem_reporting === void 0 ? void 0 : (_this_sessionItem_reporting_assetMetadata = _this_sessionItem_reporting.assetMetadata) === null || _this_sessionItem_reporting_assetMetadata === void 0 ? void 0 : (_this_sessionItem_reporting_assetMetadata_seasonNumber = _this_sessionItem_reporting_assetMetadata.seasonNumber) === null || _this_sessionItem_reporting_assetMetadata_seasonNumber === void 0 ? void 0 : _this_sessionItem_reporting_assetMetadata_seasonNumber.toString();
            }
        },
        {
            key: "getPlayoutType",
            value: function getPlayoutType() {
                var _this_playoutData;
                return (_this_playoutData = this.playoutData) === null || _this_playoutData === void 0 ? void 0 : _this_playoutData.type;
            }
        },
        {
            key: "getMvpd",
            value: function getMvpd() {
                var _this_sessionItem_reporting_assetMetadata, _this_sessionItem_reporting, _this_sessionItem;
                return (_this_sessionItem = this.sessionItem) === null || _this_sessionItem === void 0 ? void 0 : (_this_sessionItem_reporting = _this_sessionItem.reporting) === null || _this_sessionItem_reporting === void 0 ? void 0 : (_this_sessionItem_reporting_assetMetadata = _this_sessionItem_reporting.assetMetadata) === null || _this_sessionItem_reporting_assetMetadata === void 0 ? void 0 : _this_sessionItem_reporting_assetMetadata.videoMvpd;
            }
        },
        {
            key: "getTmsShowID",
            value: function getTmsShowID() {
                var _this_sessionItem_reporting_assetMetadata, _this_sessionItem_reporting, _this_sessionItem;
                return (_this_sessionItem = this.sessionItem) === null || _this_sessionItem === void 0 ? void 0 : (_this_sessionItem_reporting = _this_sessionItem.reporting) === null || _this_sessionItem_reporting === void 0 ? void 0 : (_this_sessionItem_reporting_assetMetadata = _this_sessionItem_reporting.assetMetadata) === null || _this_sessionItem_reporting_assetMetadata === void 0 ? void 0 : _this_sessionItem_reporting_assetMetadata.videoTmsId;
            }
        },
        {
            key: "getStartPosition",
            value: function getStartPosition() {
                var _this_playoutData;
                return "".concat(((_this_playoutData = this.playoutData) === null || _this_playoutData === void 0 ? void 0 : _this_playoutData.position) || 0);
            }
        },
        {
            key: "getEpisodeNumber",
            value: function getEpisodeNumber() {
                var _this_sessionItem_reporting_assetMetadata_episodeNumber, _this_sessionItem_reporting_assetMetadata, _this_sessionItem_reporting, _this_sessionItem;
                return (_this_sessionItem = this.sessionItem) === null || _this_sessionItem === void 0 ? void 0 : (_this_sessionItem_reporting = _this_sessionItem.reporting) === null || _this_sessionItem_reporting === void 0 ? void 0 : (_this_sessionItem_reporting_assetMetadata = _this_sessionItem_reporting.assetMetadata) === null || _this_sessionItem_reporting_assetMetadata === void 0 ? void 0 : (_this_sessionItem_reporting_assetMetadata_episodeNumber = _this_sessionItem_reporting_assetMetadata.episodeNumber) === null || _this_sessionItem_reporting_assetMetadata_episodeNumber === void 0 ? void 0 : _this_sessionItem_reporting_assetMetadata_episodeNumber.toString();
            }
        },
        {
            key: "getAdProvider",
            value: function getAdProvider() {
                var _this_sessionItem;
                switch((_this_sessionItem = this.sessionItem) === null || _this_sessionItem === void 0 ? void 0 : _this_sessionItem.type){
                    case PlaybackType.VOD:
                    case PlaybackType.Clip:
                        return 'CMT';
                    case PlaybackType.FER:
                    case PlaybackType.SingleLiveEvent:
                    case PlaybackType.Live:
                        return 'CTS';
                    default:
                        return undefined;
                }
            }
        },
        {
            key: "getCallSign",
            value: function getCallSign() {
                var _this_sessionItem_reporting_assetMetadata, _this_sessionItem_reporting, _this_sessionItem;
                return (_this_sessionItem = this.sessionItem) === null || _this_sessionItem === void 0 ? void 0 : (_this_sessionItem_reporting = _this_sessionItem.reporting) === null || _this_sessionItem_reporting === void 0 ? void 0 : (_this_sessionItem_reporting_assetMetadata = _this_sessionItem_reporting.assetMetadata) === null || _this_sessionItem_reporting_assetMetadata === void 0 ? void 0 : _this_sessionItem_reporting_assetMetadata.callSign;
            }
        },
        {
            key: "getDeviceBrand",
            value: function getDeviceBrand(deviceInfo) {
                return deviceInfo.deviceBrand;
            }
        },
        {
            key: "getShow",
            value: function getShow() {
                var _this_sessionItem_reporting_assetMetadata, _this_sessionItem_reporting, _this_sessionItem;
                return (_this_sessionItem = this.sessionItem) === null || _this_sessionItem === void 0 ? void 0 : (_this_sessionItem_reporting = _this_sessionItem.reporting) === null || _this_sessionItem_reporting === void 0 ? void 0 : (_this_sessionItem_reporting_assetMetadata = _this_sessionItem_reporting.assetMetadata) === null || _this_sessionItem_reporting_assetMetadata === void 0 ? void 0 : _this_sessionItem_reporting_assetMetadata.seriesTitle;
            }
        },
        {
            key: "getProfile",
            value: function getProfile() {
                var _this_sessionItem_user, _this_sessionItem;
                if ((_this_sessionItem = this.sessionItem) === null || _this_sessionItem === void 0 ? void 0 : (_this_sessionItem_user = _this_sessionItem.user) === null || _this_sessionItem_user === void 0 ? void 0 : _this_sessionItem_user.authenticated) {
                    return 'Free';
                }
                return 'Unauthenticated';
            }
        },
        {
            key: "getEntitlement",
            value: function getEntitlement() {
                var _this_playoutData;
                var allowedContentTypes = [
                    PlaybackType.VOD,
                    PlaybackType.Live,
                    PlaybackType.SingleLiveEvent,
                    PlaybackType.FER
                ];
                if (((_this_playoutData = this.playoutData) === null || _this_playoutData === void 0 ? void 0 : _this_playoutData.type) && allowedContentTypes.includes(this.playoutData.type)) {
                    var _this_sessionItem_reporting_assetMetadata, _this_sessionItem_reporting, _this_sessionItem;
                    if ((_this_sessionItem = this.sessionItem) === null || _this_sessionItem === void 0 ? void 0 : (_this_sessionItem_reporting = _this_sessionItem.reporting) === null || _this_sessionItem_reporting === void 0 ? void 0 : (_this_sessionItem_reporting_assetMetadata = _this_sessionItem_reporting.assetMetadata) === null || _this_sessionItem_reporting_assetMetadata === void 0 ? void 0 : _this_sessionItem_reporting_assetMetadata.entitled) {
                        return 'Entitled';
                    }
                    return 'Free';
                }
            }
        },
        {
            key: "getSyndicator",
            value: function getSyndicator() {
                var _this_sessionItem_reporting_assetMetadata, _this_sessionItem_reporting, _this_sessionItem, _this_sessionItem_user, _this_sessionItem1;
                var mvpd = (_this_sessionItem = this.sessionItem) === null || _this_sessionItem === void 0 ? void 0 : (_this_sessionItem_reporting = _this_sessionItem.reporting) === null || _this_sessionItem_reporting === void 0 ? void 0 : (_this_sessionItem_reporting_assetMetadata = _this_sessionItem_reporting.assetMetadata) === null || _this_sessionItem_reporting_assetMetadata === void 0 ? void 0 : _this_sessionItem_reporting_assetMetadata.videoMvpd;
                var authenticationProvider = (_this_sessionItem1 = this.sessionItem) === null || _this_sessionItem1 === void 0 ? void 0 : (_this_sessionItem_user = _this_sessionItem1.user) === null || _this_sessionItem_user === void 0 ? void 0 : _this_sessionItem_user.authenticationProvider;
                if (mvpd) {
                    return mvpd;
                } else if (authenticationProvider) {
                    return authenticationProvider;
                }
                return 'Unauthenticated';
            }
        },
        {
            key: "getNonLinearAssetName",
            value: function getNonLinearAssetName(metadata, episodeTitle) {
                var _metadata_seriesTitle;
                return "[".concat(metadata === null || metadata === void 0 ? void 0 : metadata.id, "] ").concat((_metadata_seriesTitle = metadata === null || metadata === void 0 ? void 0 : metadata.seriesTitle) !== null && _metadata_seriesTitle !== void 0 ? _metadata_seriesTitle : metadata === null || metadata === void 0 ? void 0 : metadata.title).concat(episodeTitle);
            }
        },
        {
            key: "getLinearAssetName",
            value: function getLinearAssetName(metadata, episodeTitle) {
                return "[".concat(metadata === null || metadata === void 0 ? void 0 : metadata.programmeId, "] ").concat(metadata === null || metadata === void 0 ? void 0 : metadata.programmeTitle).concat(episodeTitle);
            }
        },
        {
            key: "getFallbackAssetName",
            value: function getFallbackAssetName(metadata, episodeTitle) {
                var _metadata_programmeId, _metadata_programmeTitle;
                return "[".concat((_metadata_programmeId = metadata === null || metadata === void 0 ? void 0 : metadata.programmeId) !== null && _metadata_programmeId !== void 0 ? _metadata_programmeId : metadata === null || metadata === void 0 ? void 0 : metadata.id, "] ").concat((_metadata_programmeTitle = metadata === null || metadata === void 0 ? void 0 : metadata.programmeTitle) !== null && _metadata_programmeTitle !== void 0 ? _metadata_programmeTitle : metadata === null || metadata === void 0 ? void 0 : metadata.title).concat(episodeTitle);
            }
        },
        {
            key: "getAssetName",
            value: function getAssetName() {
                var _this_sessionItem_reporting, _this_sessionItem, _this_sessionItem1;
                var metadata = (_this_sessionItem = this.sessionItem) === null || _this_sessionItem === void 0 ? void 0 : (_this_sessionItem_reporting = _this_sessionItem.reporting) === null || _this_sessionItem_reporting === void 0 ? void 0 : _this_sessionItem_reporting.assetMetadata;
                var episodeTitle = (metadata === null || metadata === void 0 ? void 0 : metadata.episodeTitle) ? " - ".concat(metadata === null || metadata === void 0 ? void 0 : metadata.episodeTitle) : '';
                switch((_this_sessionItem1 = this.sessionItem) === null || _this_sessionItem1 === void 0 ? void 0 : _this_sessionItem1.type){
                    case PlaybackType.VOD:
                    case PlaybackType.FER:
                    case PlaybackType.Clip:
                        return this.getNonLinearAssetName(metadata, episodeTitle);
                    case PlaybackType.Live:
                    case PlaybackType.SingleLiveEvent:
                        return this.getLinearAssetName(metadata, episodeTitle);
                    default:
                        return this.getFallbackAssetName(metadata, episodeTitle);
                }
            }
        },
        {
            key: "getVideoId",
            value: function getVideoId() {
                var _this_playoutData_assetMetadata, _this_playoutData, _this_sessionItem_reporting_assetMetadata, _this_sessionItem_reporting, _this_sessionItem, _this_sessionItem1;
                var assetId = (_this_playoutData = this.playoutData) === null || _this_playoutData === void 0 ? void 0 : (_this_playoutData_assetMetadata = _this_playoutData.assetMetadata) === null || _this_playoutData_assetMetadata === void 0 ? void 0 : _this_playoutData_assetMetadata.assetId;
                var programmeId = (_this_sessionItem = this.sessionItem) === null || _this_sessionItem === void 0 ? void 0 : (_this_sessionItem_reporting = _this_sessionItem.reporting) === null || _this_sessionItem_reporting === void 0 ? void 0 : (_this_sessionItem_reporting_assetMetadata = _this_sessionItem_reporting.assetMetadata) === null || _this_sessionItem_reporting_assetMetadata === void 0 ? void 0 : _this_sessionItem_reporting_assetMetadata.programmeId;
                switch((_this_sessionItem1 = this.sessionItem) === null || _this_sessionItem1 === void 0 ? void 0 : _this_sessionItem1.type){
                    case PlaybackType.VOD:
                    case PlaybackType.Clip:
                        return assetId;
                    case PlaybackType.Live:
                    case PlaybackType.FER:
                    case PlaybackType.SingleLiveEvent:
                        return programmeId;
                    default:
                        return assetId !== null && assetId !== void 0 ? assetId : programmeId;
                }
            }
        },
        {
            key: "getResellerName",
            value: function getResellerName() {
                // PBSCVJSSS-571
                // resellerName can be blank for now
                return undefined;
            }
        },
        {
            key: "getSiteSectionID",
            value: function getSiteSectionID() {
                // PBSCVJSSS-571
                // Unfortunately, MrmSiteSectionID is not something that we can reliably get from any source (including the ads response).
                // For now, we are sufficient with tracking siteSection.
                return undefined;
            }
        },
        {
            key: "getVideoSport",
            value: function getVideoSport() {
                var _this_sessionItem_reporting_assetMetadata, _this_sessionItem_reporting, _this_sessionItem;
                return ((_this_sessionItem = this.sessionItem) === null || _this_sessionItem === void 0 ? void 0 : (_this_sessionItem_reporting = _this_sessionItem.reporting) === null || _this_sessionItem_reporting === void 0 ? void 0 : (_this_sessionItem_reporting_assetMetadata = _this_sessionItem_reporting.assetMetadata) === null || _this_sessionItem_reporting_assetMetadata === void 0 ? void 0 : _this_sessionItem_reporting_assetMetadata.sport) || 'NA';
            }
        },
        {
            key: "getVideoLeague",
            value: function getVideoLeague() {
                var _this_sessionItem_reporting_assetMetadata, _this_sessionItem_reporting, _this_sessionItem;
                return ((_this_sessionItem = this.sessionItem) === null || _this_sessionItem === void 0 ? void 0 : (_this_sessionItem_reporting = _this_sessionItem.reporting) === null || _this_sessionItem_reporting === void 0 ? void 0 : (_this_sessionItem_reporting_assetMetadata = _this_sessionItem_reporting.assetMetadata) === null || _this_sessionItem_reporting_assetMetadata === void 0 ? void 0 : _this_sessionItem_reporting_assetMetadata.league) || 'NA';
            }
        },
        {
            key: "getEventType",
            value: function getEventType() {
                var _this_sessionItem_reporting_assetMetadata, _this_sessionItem_reporting, _this_sessionItem;
                return ((_this_sessionItem = this.sessionItem) === null || _this_sessionItem === void 0 ? void 0 : (_this_sessionItem_reporting = _this_sessionItem.reporting) === null || _this_sessionItem_reporting === void 0 ? void 0 : (_this_sessionItem_reporting_assetMetadata = _this_sessionItem_reporting.assetMetadata) === null || _this_sessionItem_reporting_assetMetadata === void 0 ? void 0 : _this_sessionItem_reporting_assetMetadata.eventType) || 'NA';
            }
        },
        {
            key: "getMutedVideoStart",
            value: function getMutedVideoStart() {
                var _this_sessionItem;
                // Use string booleans. Conviva ignores tags if they are of type boolean, and does not send them in the network request to Conviva servers.
                return ((_this_sessionItem = this.sessionItem) === null || _this_sessionItem === void 0 ? void 0 : _this_sessionItem.muted) ? 'true' : 'false';
            }
        },
        {
            key: "isFromBackground",
            value: function isFromBackground() {
                var _this_sessionItem_reporting_assetMetadata, _this_sessionItem_reporting, _this_sessionItem;
                // Use string booleans. Conviva ignores tags if they are of type boolean, and does not send them in the network request to Conviva servers.
                return ((_this_sessionItem = this.sessionItem) === null || _this_sessionItem === void 0 ? void 0 : (_this_sessionItem_reporting = _this_sessionItem.reporting) === null || _this_sessionItem_reporting === void 0 ? void 0 : (_this_sessionItem_reporting_assetMetadata = _this_sessionItem_reporting.assetMetadata) === null || _this_sessionItem_reporting_assetMetadata === void 0 ? void 0 : _this_sessionItem_reporting_assetMetadata.isFromBackground) ? 'true' : 'false';
            }
        },
        {
            key: "getVideoLanguage",
            value: function getVideoLanguage() {
                var _this_sessionItem_reporting_assetMetadata, _this_sessionItem_reporting, _this_sessionItem;
                return (_this_sessionItem = this.sessionItem) === null || _this_sessionItem === void 0 ? void 0 : (_this_sessionItem_reporting = _this_sessionItem.reporting) === null || _this_sessionItem_reporting === void 0 ? void 0 : (_this_sessionItem_reporting_assetMetadata = _this_sessionItem_reporting.assetMetadata) === null || _this_sessionItem_reporting_assetMetadata === void 0 ? void 0 : _this_sessionItem_reporting_assetMetadata.videoLanguage;
            }
        },
        {
            key: "getProductName",
            value: function getProductName() {
                var _this_convivaAddonInfo;
                return ((_this_convivaAddonInfo = this.convivaAddonInfo) === null || _this_convivaAddonInfo === void 0 ? void 0 : _this_convivaAddonInfo.appName) || 'unknown';
            }
        },
        {
            key: "getStreamType",
            value: function getStreamType() {
                var _this_sessionItem;
                switch((_this_sessionItem = this.sessionItem) === null || _this_sessionItem === void 0 ? void 0 : _this_sessionItem.type){
                    case PlaybackType.VOD:
                        return LegacyReportingStreamType.VOD;
                    case PlaybackType.Clip:
                        return LegacyReportingStreamType.Clip;
                    case PlaybackType.Preview:
                        return LegacyReportingStreamType.Preview;
                    case PlaybackType.Live:
                        return LegacyReportingStreamType.Live;
                    case PlaybackType.SingleLiveEvent:
                        return LegacyReportingStreamType.SingleLiveEvent;
                    case PlaybackType.FER:
                        return LegacyReportingStreamType.FullEventReplay;
                    default:
                        return null;
                }
            }
        },
        {
            key: "getEntertainmentCustomTags",
            value: function getEntertainmentCustomTags(metadata) {
                // noop
                return {};
            }
        },
        {
            key: "getVodCustomTags",
            value: function getVodCustomTags(metadata) {
                // noop
                return {};
            }
        },
        {
            key: "getLiveCustomTags",
            value: function getLiveCustomTags(metadata) {
                // noop
                return {};
            }
        }
    ]);
    return OneAppConvivaTagsProvider;
}(ConvivaTagsProvider);

//# sourceMappingURL=oneapp-conviva-tags-provider.js.map